import React from "react";
import ContactsHeader from "./ContactsHeader";
import ContactPageForm from "./ContactPageForm";
import ContactPageMap from "./ContactPageMap";

const MainContacts = () => {
  return (
    <div>
      <ContactsHeader />
      <ContactPageForm />
      <ContactPageMap />
    </div>
  );
};

export default MainContacts;
